import { useEffect } from 'react';
import TldrawCanvas from './canvas/TldrawCanvas';
import DiscordProvider from './discord/DiscordProvider';
import { useDiscordAuth } from './hooks/useDiscordAuth';

function App() {
  const { isAuthenticated, isLoading, error, authenticate } = useDiscordAuth();

  useEffect(() => {
    if (!isAuthenticated && !isLoading) {
      authenticate();
    }
  }, [isAuthenticated, isLoading, authenticate]);

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner" />
        <p>Loading Discord...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-container">
        <h1 className="error-title">Authentication Error</h1>
        <p className="error-message">{error}</p>
        <button
          onClick={authenticate}
          style={{
            marginTop: '16px',
            padding: '12px 24px',
            background: '#5865F2',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
          }}
        >
          Retry
        </button>
      </div>
    );
  }

  return (
    <DiscordProvider>
      <div style={{ width: '100%', height: '100%' }}>
        <TldrawCanvas />
      </div>
    </DiscordProvider>
  );
}

export default App;
